import { useEffect, useRef } from "react";
import type { ChatMessage } from "./KaiChatBtn";

export function ChatMessages({
  messages,
  typing,
}: {
  messages: ChatMessage[];
  typing: boolean;
}) {
  const chatRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    chatRef.current?.scrollTo({
      top: chatRef.current.scrollHeight,
      behavior: "smooth",
    });
  }, [messages, typing]);

  return (
    <div
      className="flex-1 overflow-y-auto p-4 space-y-3 bg-gray-50"
      ref={chatRef}
    >
      {messages.map((msg, idx) => (
        <ChatMessage key={idx} msg={msg} />
      ))}

      {typing && <TypingIndicator />}
    </div>
  );
}

function ChatMessage({ msg }: { msg: ChatMessage }) {
  const formatMessage = (text: string) => {
    return text
      ?.replace(
        /(https?:\/\/[^\s]+)/g,
        (url) =>
          `<a href="${url}" class="${
            msg.sender === "user" ? "text-blue-100" : "text-blue-500"
          } underline" target="_blank">${url}</a>`
      )
      .replace(/\\n/g, "<br>")
      .replace(/\n/g, "<br>");
  };

  return (
    <div
      className={`flex ${
        msg.sender === "user" ? "justify-end" : "justify-start"
      }`}
    >
      <div
        className={`max-w-[75%] rounded-2xl px-4 py-2 shadow-sm ${
          msg.sender === "user"
            ? "bg-blue-600 text-white rounded-br-none"
            : "bg-white text-gray-800 rounded-bl-none border border-gray-200"
        }`}
      >
        <div
          className="break-words break-all whitespace-pre-wrap"
          dangerouslySetInnerHTML={{
            __html: formatMessage(msg.content),
          }}
        />

        <div
          className={`text-[10px] ${
            msg.sender === "user" ? "text-gray-300" : "text-gray-400"
          } text-right mt-1`}
        >
          {msg.time}
        </div>
      </div>
    </div>
  );
}

function TypingIndicator() {
  return (
    <div className="flex justify-start">
      <div className="bg-white border border-gray-200 rounded-2xl px-3 py-2 shadow-sm">
        <div className="flex space-x-1">
          <div className="w-2 h-2 bg-gray-400 rounded-full animate-bounce"></div>
          <div className="w-2 h-2 bg-gray-400 rounded-full animate-bounce delay-150"></div>
          <div className="w-2 h-2 bg-gray-400 rounded-full animate-bounce delay-300"></div>
        </div>
      </div>
    </div>
  );
}
